import {
  BucketAwtENUM,
  diffDaysLabel,
  EstadoPreventaEnum,
  EstadoProspectoEnum,
  handleErrorForm,
  ROUTER_PATHS,
  TipoFormaPagoEnumChoice,
  TipoIdentificacionEnumChoice,
  TipoPlanEnumChoice,
  TipoServicioEnumChoice,
  useLoaders,
  useUploadFile,
  ValorCompletoInstalacionSinIvaPymes,
  ValorSinIvaRadioPymes,
} from "@/shared";
import {
  getAllNaps,
  getPaymentMethodsV2,
  searchDataByCedulaDirecto,
  useFetchCalcularValorInstalacion,
  useFetchEntidadesFinancieras,
  useFetchParametros,
} from "@/shared/actions/erp";
import { useFetchCooperativa } from "@/shared/actions/erp/cooperativa.actions";
import {
  AlertSeverityEnum,
  EntidadesFinancieras,
  IDataPreventa,
  IPaymentMethod,
  PaymentMethodEnum,
  Plan,
  TipoContratoENUM,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import {
  IPaymentMethodV2,
  TipoPagoV2Enum,
} from "@/shared/interfaces/erp/system-settings";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import CardValidator from "card-validator";
import { useUiStore } from "@/store/ui";
import { useNavigate } from "react-router-dom";
import { emailENUM } from "@/erp/sale/asesor";
import { useLocalidad } from "@/shared/hooks/useLocalidad";
import {
  useFetchPostCreatePreventaPymes,
  useFetchPutPreventaPymes,
} from "@/shared/actions/erp/preventa_pymes/preventa_pymes.action";
import { IProspectoPymes } from "@/shared/interfaces/erp/ventas_pymes/prospecto_pymes.interface";
import {
  CoordenadasPymesDefault,
  InfoPuntoEnlace,
  IPreventaPymesForm,
} from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import { v4 as uuidv4 } from "uuid";
import { yupResolver } from "@hookform/resolvers/yup";
import { newPreventaPymesSchema } from "@/shared/utils/validation-schemas/erp/ventas/preventa/preventapymes.schema";
import {
  postProspectoPymes,
  useGetProspectoPymes,
} from "@/shared/actions/erp/prospecto_pymes.action";
import { useAuthStore } from "@/store/auth";
import { toast } from "react-toastify";
import { validateSellByOtherUser } from "@/shared/actions/erp/prospecto_corporativo.actions";

type ErrorItem = {
  [key: string]: {
    message: string;
    type: string;
    ref: any;
  };
};

type useFormPreventaProps = {
  editSupervisor: boolean;
  dataPreventa?: IDataPreventa;
  prospectoResp?: IProspectoPymes | null; ///* data de prospecto desde un fetch
};

export const useFormPreventaPymes = ({
  prospectoResp,
}: useFormPreventaProps) => {
  const navigate = useNavigate();

  ///* state
  const [modalMapa, setModalMapa] = useState<boolean>(false);
  const [tipoTarjeta, setTipoTarjeta] = useState<string | null>(null);
  const [docHabilitantes, setDocHabilitantes] = useState<File | null>(null);
  const [dataProspecto, setDataProspecto] = useState<IProspectoPymes | null>(
    null,
  );
  const [enabledProspecto, setEnabledProspecto] = useState(false);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const currentUsername = useAuthStore(s => s.user)?.username!
  const user = useAuthStore((s) => s.user);

  // V2 - 3 niveles de pago
  const [entidadesV2Filtradas, setEntidadesV2Filtradas] = useState<
    EntidadesFinancieras[]
  >([]);
  const [isLoadingEntidadesV2, setIsLoadingEntidadesV2] =
    useState<boolean>(false);
  const [formasPagoV2Filtradas, setFormasPagoV2Filtradas] = useState<
    IPaymentMethodV2[]
  >([]);
  const [isLoadingFormasPagoV2, setIsLoadingFormasPagoV2] =
    useState<boolean>(false);
  const [selectedCardTypeName, setSelectedCardTypeName] = useState<
    string | null
  >(null);
  const [valorRestriccionCel, setValorRestriccionCel] = useState<any>({});
  


  const schemaPreventaPymesSchema = useMemo(
    () => newPreventaPymesSchema(valorRestriccionCel),
    [valorRestriccionCel]
  );
  ///* formulario
  const form = useForm<IPreventaPymesForm, any, IPreventaPymesForm>({
    resolver: yupResolver(schemaPreventaPymesSchema as any),
    defaultValues: {
      items: [
        {
          coordenada: CoordenadasPymesDefault,
          nombre: "",
          estado: false,
          cobertura: false,
          velocidad_subida_maxima: "0",
        },
      ],
      pre_requiere_contrato_fisico: false, // false = EN_ESPERA (tab Preventas), true = PENDIENTE_DOCUMENTOS (tab Pendiente Contrato)
      es_router_ac: false,
      requiere_wifi_6: false,
      es_android_tv: false,
      es_ups: false,
      es_pago_total: false,
      numero_cantidad_wifi_6: 0,
      numero_cantidad_router_ac: 0,
      numero_cuotas_router_ac: 0,
      numero_cuotas_wifi_6: 0,
      numero_cantidad_android_tv: 0,
      numero_cuotas_android_tv: 0,
      numero_cuotas_ups: 0,
      numero_cantidad_ups: 0,
      representante_legal_tipo_identificacion:
        TipoIdentificacionEnumChoice.CEDULA,
      responsable_contable_tipo_identificacion:
        TipoIdentificacionEnumChoice.CEDULA,
      //tiempo_contrato: PermanenciasEnumChoice.TREINTAYSEIS_MESES
      tiempo_contrato: 36,
    },
  });

  const { reset, setError, clearErrors, control } = form;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  ///* store
  const plans = usePlanStore((s) => s.plans);
  const setAlert = useUiStore((s) => s.setAlert);

  ///* react query

  const { data: dataEntidadFinanciero, isLoading: isLoadingEntidadFinanciero } =
    useFetchEntidadesFinancieras({
      page_size: 600,
      enabled: form.watch("codigo_forma_pago") == PaymentMethodEnum.TARJETA,
    });

  const { mutateAsync: _updatePreventa, isPending: isPendingUpdatePreventa } =
    useFetchPutPreventaPymes({
      enableAlert: false,
    });

  const {
    mutateAsync: mutateAsyncCreatePreventa,
    isPending: isPendingPreventa,
  } = useFetchPostCreatePreventaPymes({
    navigate,
    returnUrl: ROUTER_PATHS.ventasPymes.preventaNav,
  });

  const {
    mutateAsync: fetchCalcularValorInstalacion,
    isPending: isPendingValorInstalacion,
  } = useFetchCalcularValorInstalacion({
    enableSuccessAlert: false,
  });

  const { data: dataCooperativa, isLoading: isLoadingCooperativa } =
    useFetchCooperativa({
      params: {
        entidad_financiera: form.watch("entidad_financiera")!,
        estado: true,
      },
      enabled: !!form.watch("entidad_financiera"),
    });

  const { isLoading: isLoadingProspecto, data: prospectoPreventa } =
    useGetProspectoPymes(
      {
        identificacion: form.getValues().identificacion_prospecto,
        user_create: user?.username,
        page_size: 1,
        estados_prospecto_exclude: EstadoProspectoEnum.CANCELADO,
      },
      enabledProspecto,
    );
  
  const { data: dataParamRestriccionCel, isLoading: isLoadingParamRestriccionCel } = useFetchParametros({
    enabled: true,
    params: {
      slug: "RESTRICCION_CELULAR"
    }
  });
  

  ///* hook personalizado

  const { handleUploadFile } = useUploadFile();

  const { dataSector, isLoadingSector } = useLocalidad({
    form: form as any,
    cobertura: true,
  });

  ///* buscar representante legal valido
  const handleBuscarProspecto = async (identificacion: string) => {
    if (identificacion.length == 10 || identificacion.length == 13) {
      const resp = await validateSellByOtherUser({ identificacion: identificacion });
      const prospectosInfo = resp?.data;
      if (
        prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
        || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
      ) {
        return setAlert(
          true,
          "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
          AlertSeverityEnum.warning,
          4000
        );
      }
      setEnabledProspecto(true);
      return;
    }
    setDataProspecto(null);
    setEnabledProspecto(false);
  };

  const handleSelectProspecto = (value: IProspectoPymes) => {
    if (!value) return;
    setDataProspecto(value);
  };

  ///* valor instalacion por forma de pago
  const handleValorInstalacionFormaPago = async () => {
    if (!form.getValues().codigo_forma_pago)
      return setAlert(
        true,
        "Seleccionar una forma de pago.",
        AlertSeverityEnum.info,
      );

    await fetchCalcularValorInstalacion({
      id_prospecto: dataProspecto?.id_prospecto_pymes!,
      forma_pago: form.getValues().forma_pago!,
      score: +dataProspecto?.puntaje_score_empresa!,
      segmentacion: dataProspecto?.segmentacion!,
      es_pyme: true,
    });
  };

  ///* tipo forma de pago debito, credito o transferencia
  const handleFormaPago = async (e: IPaymentMethod) => {
    setTipoTarjeta(null);
    reset({
      ...form.getValues(),
      entidad_financiera: null,
      codigo_forma_pago: "",
      tipo_contrato: "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      observacion_1: "",
      tiempo_contrato: 36,
    });

    if (!e) return;

    if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO)
      form.setValue("entidad_financiera", e.entidad_financiera);

    reset({
      ...form.getValues(),
      codigo_forma_pago: e.forma_pago,
      tipo_contrato: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
      tarjeta: e.tarjeta,
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      observacion_1: "APLICA PARA TODAS LAS CIUDADES",
      tipo_plan: form.getValues().tipo_plan,
      tarjeta_fecha_caducidad:
        e.forma_pago !== PaymentMethodEnum.TARJETA
          ? null
          : form.getValues().tarjeta_fecha_caducidad,
    });
    const itemEnlace = form.getValues().items;

    if (itemEnlace) {
      for (let index = 0; index < itemEnlace.length; index++) {
        //form.setValue(`items.${index}.plan`, null);
        const plan = plans.find((e) => e.codigo == itemEnlace[index].plan);
        if (plan) {
          enlaceValorInstalacion(
            plan,
            form.getValues().es_pago_total ?? false,
            index,
          );
        }
      }
    }
  };

  // ============ V2 - 3 niveles de pago ============

  // Handler para cuando cambia el Tipo de Pago (DÉBITO/CRÉDITO/RECAUDACIÓN)
  const handleTipoPagoV2Change = async (tipoPago: TipoPagoV2Enum) => {
    setTipoTarjeta(null);
    setSelectedCardTypeName(null);

    // Para RECAUDACIÓN y TRANSFERENCIA, forma_pago usa directamente el código V1
    // Para DÉBITO/CRÉDITO, forma_pago se establecerá cuando se seleccione la forma de pago específica
    const esSinEntidad =
      tipoPago === TipoPagoV2Enum.RECAUDACION ||
      tipoPago === TipoPagoV2Enum.TRANSFERENCIA;

    // Limpiar formulario
    reset({
      ...form.getValues(),
      tipo_pago_v2: tipoPago,
      entidad_financiera: "",
      forma_pago_v2: esSinEntidad ? tipoPago : "",
      codigo_forma_pago: esSinEntidad ? tipoPago : "",
      forma_pago: esSinEntidad ? tipoPago : null, // Código de FormaPago v1
      forma_pago_legacy: esSinEntidad ? tipoPago : null, // V1 legacy para submit
      tipo_contrato: esSinEntidad ? TipoContratoENUM.GEDATECU : "",
      tarjeta: "",
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      tarjeta_fecha_caducidad: null,
      observacion_1: esSinEntidad ? "APLICA PARA TODAS LAS CIUDADES" : "",
      tiempo_contrato: 36,
    });

    // Para RECAUDACIÓN y TRANSFERENCIA, no cargar entidades ni formas de pago
    if (esSinEntidad) {
      setEntidadesV2Filtradas([]);
      setFormasPagoV2Filtradas([]);
      // Recalcular valor instalación si hay planes seleccionados
      const itemEnlace = form.getValues().items;
      if (itemEnlace) {
        for (let index = 0; index < itemEnlace.length; index++) {
          const plan = plans.find((e) => e.codigo == itemEnlace[index].plan);
          if (plan) {
            enlaceValorInstalacion(
              plan,
              form.getValues().es_pago_total ?? false,
              index,
            );
          }
        }
      }
      return;
    }

    // Cargar entidades filtradas por tipo de pago (solo para DÉBITO y CRÉDITO)
    if (tipoPago) {
      setIsLoadingEntidadesV2(true);
      try {
        const res = await getPaymentMethodsV2({
          tipo_pago: tipoPago,
          aplica_pyme: true,
          estado: true,
          filterByState: false,
          page_size: 1000,
        });

        // Obtener entidades únicas de las formas de pago V2
        const entidadesUnicas = new Map<string, EntidadesFinancieras>();
        res.data.data.forEach((fp: IPaymentMethodV2) => {
          if (!entidadesUnicas.has(fp.entidad_financiera)) {
            entidadesUnicas.set(fp.entidad_financiera, {
              codigo: fp.entidad_financiera,
              nombre: fp.entidad_financiera,
            } as EntidadesFinancieras);
          }
        });

        setEntidadesV2Filtradas(Array.from(entidadesUnicas.values()));
        setFormasPagoV2Filtradas([]);
      } catch (error) {
        console.error("Error cargando entidades V2:", error);
        setEntidadesV2Filtradas([]);
      } finally {
        setIsLoadingEntidadesV2(false);
      }
    }
  };

  // Handler para cuando cambia la Entidad Bancaria
  const handleEntidadV2Change = async (entidadCodigo: string) => {
    // Limpiar forma de pago al cambiar entidad
    reset({
      ...form.getValues(),
      entidad_financiera: entidadCodigo,
      forma_pago_v2: "",
      codigo_forma_pago: "",
      numero_cuenta: "",
      tipo_cuenta_bancaria: "",
      numero_tarjeta: "",
      tarjeta_fecha_caducidad: null,
      valor_instalacion_total: "",
      valor_instalacion: "",
      valor_instalacion_iva: "",
    });

    // Cargar formas de pago filtradas
    if (entidadCodigo && form.getValues().tipo_pago_v2) {
      setIsLoadingFormasPagoV2(true);
      try {
        const res = await getPaymentMethodsV2({
          tipo_pago: form.getValues().tipo_pago_v2 as TipoPagoV2Enum,
          entidad_financiera: entidadCodigo,
          aplica_pyme: true,
          estado: true,
          filterByState: false,
          page_size: 1000,
        });

        let formasPagoFiltradas = res.data.data;

        // Filtro especial para COOP JEP + DÉBITO: solo mostrar "Cuenta de Ahorros"
        const tipoPagoActual = form.getValues().tipo_pago_v2;
        if (
          entidadCodigo.toUpperCase().includes("JEP") &&
          tipoPagoActual === TipoPagoV2Enum.DEBITO
        ) {
          formasPagoFiltradas = formasPagoFiltradas.filter(
            (fp: IPaymentMethodV2) =>
              fp.nombre.toLowerCase().includes("ahorro"),
          );
        }

        setFormasPagoV2Filtradas(formasPagoFiltradas);
      } catch (error) {
        console.error("Error cargando formas de pago V2:", error);
        setFormasPagoV2Filtradas([]);
      } finally {
        setIsLoadingFormasPagoV2(false);
      }
    }
  };

  // Función auxiliar para mapear nombre de forma de pago a tipo de cuenta bancaria
  const mapFormaPagoToTipoCuenta = (nombreFormaPago: string): string => {
    const nombreLower = nombreFormaPago.toLowerCase();
    if (nombreLower.includes("amiga")) return "AMIGA";
    if (nombreLower.includes("corriente")) return "CORRIENTE";
    if (nombreLower.includes("ahorro")) return "AHORRO";
    return "";
  };

  // Handler para cuando se selecciona una Forma de Pago V2
  const handleFormaPagoV2Change = async (formaPago: IPaymentMethodV2) => {
    setTipoTarjeta(null);
    setSelectedCardTypeName(null);

    if (!formaPago) {
      reset({
        ...form.getValues(),
        forma_pago_v2: "",
        codigo_forma_pago: "",
      });
      return;
    }

    // Guardar el nombre del tipo de tarjeta si es CRÉDITO
    if (formaPago.tipo_pago === TipoPagoV2Enum.CREDITO) {
      setSelectedCardTypeName(formaPago.nombre);
    }

    // Mapeo automático de tipo_cuenta_bancaria basado en el nombre de la forma de pago (solo para DÉBITO)
    const tipoCuentaAutomatico =
      formaPago.tipo_pago === TipoPagoV2Enum.DEBITO
        ? mapFormaPagoToTipoCuenta(formaPago.nombre)
        : "";

    console.log("handleFormaPagoV2Change:", {
      formaPagoV2Codigo: formaPago.codigo,
      formaPagoLegacy: formaPago.forma_pago_legacy,
      tarjeta: formaPago.forma_pago_legacy_data?.tarjeta,
    });

    reset({
      ...form.getValues(),
      forma_pago_v2: formaPago.codigo,
      codigo_forma_pago: formaPago.codigo,
      // forma_pago usa PaymentMethodEnum durante el handling (igual que HOME)
      forma_pago:
        formaPago.tipo_pago === TipoPagoV2Enum.DEBITO
          ? PaymentMethodEnum.DEBITO
          : PaymentMethodEnum.TARJETA,
      // forma_pago_legacy guarda el código V1 para usarlo en el submit
      forma_pago_legacy: formaPago.forma_pago_legacy || null,
      tarjeta: formaPago.forma_pago_legacy_data?.tarjeta || null,
      tipo_contrato: TipoContratoENUM.GEDATECU,
      numero_cuenta: "",
      tipo_cuenta_bancaria: tipoCuentaAutomatico,
      numero_tarjeta: "",
      observacion_1: "APLICA PARA TODAS LAS CIUDADES",
      tiempo_contrato: 36,
    });

    // Recalcular valor instalación si hay planes seleccionados
    const itemEnlace = form.getValues().items;
    if (itemEnlace) {
      for (let index = 0; index < itemEnlace.length; index++) {
        const plan = plans.find((e) => e.codigo == itemEnlace[index].plan);
        if (plan) {
          enlaceValorInstalacion(
            plan,
            form.getValues().es_pago_total ?? false,
            index,
          );
        }
      }
    }
  };

  // Mapeo de nombres de tarjeta a tipos de card-validator
  const cardTypeMapping: Record<string, string> = {
    Visa: "visa",
    Mastercard: "mastercard",
    Discover: "discover",
    Diners: "diners-club",
  };

  const handleValidarTarjeta = (numeroTarjeta: string) => {
    const numberValidation = CardValidator.number(numeroTarjeta);

    // Detectar tipo de tarjeta de forma reactiva (incluso con números parciales)
    if (numberValidation.card) {
      setTipoTarjeta(numberValidation.card.type);

      // Validar que el tipo de tarjeta coincida con el seleccionado - REACTIVO
      if (selectedCardTypeName) {
        const expectedCardType = cardTypeMapping[selectedCardTypeName];
        const detectedCardType = numberValidation.card.type;

        if (expectedCardType && detectedCardType !== expectedCardType) {
          setError("numero_tarjeta", {
            message: `Debe ingresar una tarjeta ${selectedCardTypeName}. Se detectó: ${numberValidation.card.niceType}`,
          });
          return;
        }
      }
    } else {
      setTipoTarjeta("");
    }

    // Validar formato completo solo si tiene suficientes dígitos
    if (numeroTarjeta.length >= 13) {
      if (!numberValidation.isValid) {
        const mensajeError = selectedCardTypeName
          ? `Ingrese un número de tarjeta válido para: ${selectedCardTypeName}`
          : "Ingresar una tarjeta válida";
        setError("numero_tarjeta", {
          message: mensajeError,
        });
      } else {
        clearErrors("numero_tarjeta");
      }
    } else {
      clearErrors("numero_tarjeta");
    }
  };

  const handleSelectPlan = async (plan: Plan) => {
    console.log(plan);
    return;

    reset({
      ...form.getValues(),
      es_pago_total: false,
      es_android_tv: false,
      numero_cuotas_android_tv: 0,
      numero_cantidad_android_tv: 0,
    });

    if (plan) {
      reset({
        ...form.getValues(),
        velocidad: plan.velocidad_subida_maxima,
        unidad: plan.unidad,
        valor_plan: plan.valor,
      });

      //await aplicaPromocion(plan.codigo);
    }
  };

  const handleOnSubmit = async (formPreventa: IPreventaPymesForm) => {
    const resp = await validateSellByOtherUser({ identificacion: form.getValues()?.identificacion_prospecto ?? dataProspecto?.identificacion });
    const prospectosInfo = resp?.data;
    if (
      prospectosInfo?.prospectos_corporativos?.length > 0 && prospectosInfo?.prospectos_corporativos?.[0]?.user_create__username != currentUsername 
      || prospectosInfo?.prospectos_pymes?.length > 0 && prospectosInfo?.prospectos_pymes?.[0]?.user_create__username != currentUsername
    ) {
      return setAlert(
        true,
        "El cliente que intentas ingresar corresponde a otro Asesor. Por favor, contacte un Supervisor.",
        AlertSeverityEnum.warning,
        4000
      );
    }
    const result = esUnico(formPreventa.items ?? []);

    if (!result) {
      setAlert(
        true,
        "Se detecto que existen enlaces duplicados. Por favor, revísalos para evitar confusiones.",
        AlertSeverityEnum.error,
      );
      return;
    }

    if (!docHabilitantes) {
      return setAlert(
        true,
        "Cargar los documentos habilitantes.",
        AlertSeverityEnum.info,
      );
    }

    if (formPreventa.items?.some((e) => !e.cobertura)) {
      return setAlert(
        true,
        "Existe enlace sin cobertura disponible.",
        AlertSeverityEnum.info,
      );
    }

    const esValorInstalacionCero =
      handleValidarTipoVenta == TipoSolicitudesEnum.PYMES;

    console.log("formPreventa", formPreventa);

    const coordenadaItems = formPreventa.items?.map((element) => {
      const [lat, lng] = element.coordenada.split(",");

      return {
        ...element,
        persona_encargada:
          handleValidarTipoVenta != TipoSolicitudesEnum.PYMES
            ? dataProspecto?.solictud_evento_data?.nombre_contacto
            : null,
        tiempo_evento:
          handleValidarTipoVenta != TipoSolicitudesEnum.PYMES
            ? diffDaysLabel(
                formPreventa.fecha_inicio_contrato!,
                formPreventa.fecha_fin_contrato!,
              )
            : null,
        valor_instalacion: esValorInstalacionCero
          ? element.valor_instalacion
          : "0",
        valor_instalacion_iva: esValorInstalacionCero
          ? element.valor_instalacion_iva
          : "0",
        valor_instalacion_total: esValorInstalacionCero
          ? element.valor_instalacion_total
          : "0",
        codigo: uuidv4(),
        lat: lat,
        lng: lng,
      };
    });

    formPreventa.coordenadas = coordenadaItems!;
    delete formPreventa.valor_instalacion;
    delete formPreventa.valor_instalacion_iva;
    delete formPreventa.valor_instalacion_total;

    ///* cuando es pymes por canje o evento el contrato es fisico

    try {
      ///* Cargar documentos
      const documentos_habilitantes = await handleUploadFile(
        docHabilitantes!,
        BucketAwtENUM.DOCUMENTO_PYEMES,
      );
      formPreventa.url_documentos_habilitantes = documentos_habilitantes.url;

      ///* validar datos

      formPreventa.observaciones = {
        observacion_1: form.getValues().observacion_1 ?? "",
        observacion_2: form.getValues().observacion_2 ?? "",
      };

      formPreventa.condicion_residencia = dataProspecto?.residencia_permanente
        ? "PERMANENTE"
        : "NO PERMANENTE";

      formPreventa.email =
        form.getValues().servicio_correo != emailENUM.MANUALMENTE
          ? `${form.getValues().email_temporal}${
              form.getValues().servicio_correo
            }`
          : form.getValues().email_temporal;

      ///* Validar si es evento/canje
      const esEventoCanje = [
        TipoSolicitudesEnum.CANJE,
        TipoSolicitudesEnum.EVENTO,
      ].includes(handleValidarTipoVenta);

      // Cuando es canje/evento, el valor de instalación es cero y requiere contrato físico
      if (esEventoCanje) {
        formPreventa.valor_instalacion_total = "0";
        formPreventa.valor_instalacion = "0";
        formPreventa.valor_instalacion_iva = "0";
        formPreventa.pre_requiere_contrato_fisico = true;
      }

      // Asignar estado según el tipo de venta y si requiere contrato físico
      if (handleValidarTipoVenta == TipoSolicitudesEnum.PYMES) {
        formPreventa.estado_preventa = form.getValues()
          .pre_requiere_contrato_fisico
          ? EstadoPreventaEnum.PENDIENTE_DOCUMENTOS
          : EstadoPreventaEnum.EN_ESPERA;
      } else {
        // Para eventos/canjes
        formPreventa.estado_preventa = EstadoPreventaEnum.PENDIENTE_DOCUMENTOS;
      }

      ///* crear prospecto
      if (prospectoResp == null) {
        delete dataProspecto?.codigo;
        delete dataProspecto?.numero_referencia;

        const respProspecto = await postProspectoPymes({
          ...dataProspecto,
          solicitud_canje: form.getValues().solicitud_canje ?? null,
          solicitud_evento: form.getValues().solicitud_evento ?? null,
          es_pyme: true,
          trazo_venta_data: null,
          contrato: null,
        } as any);

        if (respProspecto.code != 200)
          return setAlert(
            true,
            "Lo sentimos no se ah podido crear el propecto. Intentalo nuevamente mas tarde.",
            AlertSeverityEnum.error,
          );
        formPreventa.prospecto = respProspecto.data.codigo!;
      } else {
        formPreventa.prospecto = prospectoResp.codigo;
      }

      // V2: Usar forma_pago_legacy para mantener compatibilidad con V1 (igual que HOME)
      formPreventa.forma_pago =
        form.getValues().forma_pago_legacy || (null as any);
      formPreventa.forma_pago_v2 = form.getValues().forma_pago_v2!;
      formPreventa.tipo_pago_v2 = form.getValues().tipo_pago_v2!;

      console.log("handleOnSubmit - FormaPago mapping:", {
        forma_pago_original: formPreventa.forma_pago,
        forma_pago_legacy: form.getValues().forma_pago_legacy,
        forma_pago_v2: form.getValues().forma_pago_v2,
        tipo_pago_v2: form.getValues().tipo_pago_v2,
      });

      await mutateAsyncCreatePreventa(formPreventa);
    } catch (error) {
      //handleRollBack(formPreventa, error);
    } finally {
      //setIsGlobalLoading(false);
    }
  };

  const handlePlanes = (): Plan[] => {
    const planPymes = plans
      .map((plan) => {
        return {
          ...plan,
          nombre: `${plan.nombre} - ${plan.tipo_servicio}`,
        };
      })
      .filter(
        (e) => e.tipo_plan == TipoPlanEnumChoice.PYMES,
        //&& e.tipo_servicio == form.getValues().tipo_servicio
      );

    return planPymes;
  };

  const handleError = (error: any) => {
    if (error.items) {
      let arr = error.items as ErrorItem[];
      const mensajes = arr
        .map((errObj) => Object.values(errObj)[0]?.message)
        .filter(Boolean);
      mensajes.forEach((element, index) => {
        setAlert(
          true,
          `${element}. Enlace ${index + 1}`,
          AlertSeverityEnum.error,
        );
      });
      return;
    }

    handleErrorForm(error);
  };

  ///* funcion aux

  function esUnico(items: InfoPuntoEnlace[]): boolean {
    const coords = items.map((i) => i.coordenada);
    const names = items.map((i) => i.nombre);
    return (
      new Set(coords).size === coords.length &&
      new Set(names).size === names.length
    );
  }

  const handleBuscarRepresententeLegal = useCallback(async () => {
    try {
      const resp = await searchDataByCedulaDirecto({
        identificacion: form.getValues().representante_legal_identificacion!,
      });
      if (resp.code != 200) return;
      const data = resp.data;
      reset({
        ...form.getValues(),
        representante_legal_razon_social: data.nombre ?? data.razonSocial,
      });

      setAlert(
        true,
        "Representante legal es valido.",
        AlertSeverityEnum.success,
      );
    } catch (error) {
      setAlert(
        true,
        "Ingresar un representante legal valido.",
        AlertSeverityEnum.error,
      );
    }
  }, []);

  const handleBuscarPorCedulaSetNombre = useCallback(
    async (identificacion: string, key: string) => {
      try {
        const resp = await searchDataByCedulaDirecto({
          identificacion: identificacion,
        });
        if (resp.code != 200)
          return toast.warning("Ingresar un representante legal valido.");
        const data = resp.data;
        reset({
          ...form.getValues(),
          [key]: data.nombre ?? data.razonSocial,
        });

        setAlert(true, "Identificacion es válida.", AlertSeverityEnum.success);
      } catch (error) {
        setAlert(
          true,
          "Ingresar una identificacion válida.",
          AlertSeverityEnum.error,
        );
      }
    },
    [],
  );

  // Llamada al backend para chequear cobertura

  const checkCoverage = async (coordenada: string, index: number) => {
    console.log(coordenada);

    if (!coordenada) {
      form.setValue(`items.${index}.cobertura`, false);
      return;
    }

    try {
      const resp = await getAllNaps({
        lat: coordenada.split(",")[0],
        lng: coordenada.split(",")[1],
        page: 1,
        page_size: 1,
      });

      form.setValue(`items.${index}.cobertura`, resp.data.count > 0);
    } catch (err) {
      console.error("Error checking coverage", err);
      form.setValue(`items.${index}.cobertura`, false);
    }
  };

  const enlaceValorInstalacion = async (
    plan: Plan,
    es_pago_total: boolean,
    index: number,
  ) => {
    // Helper que asigna total, neto e IVA (en este caso neto = total - 15%)

    const asignarValores = (total: number) => {
      const neto = total + total * 0.15;
      form.setValue(`items.${index}.valor_instalacion_total`, neto.toFixed(2));
      form.setValue(`items.${index}.valor_instalacion`, total.toFixed(2));
      form.setValue(`items.${index}.valor_instalacion_iva`, total.toFixed(2));
      form.setValue(`items.${index}.valor_plan`, plan.valor);
      form.setValue(
        `items.${index}.velocidad_subida_maxima`,
        plan.velocidad_subida_maxima,
      );
      form.setValue(`items.${index}.tipo_servicio`, plan.tipo_servicio);
      form.setValue(`items.${index}.tipo_plan`, plan.tipo_plan);
    };

    if (plan.tipo_servicio === TipoServicioEnumChoice.RADIO) {
      asignarValores(ValorSinIvaRadioPymes);
      return;
    }

    if (es_pago_total) {
      asignarValores(ValorCompletoInstalacionSinIvaPymes);
      return;
    }

    /* if (condicion_venta === TipoSolicitudesEnum.EVENTO_GRATUITO) {
        asignarValores(0);
        return;
      } */

    if (plan.tipo_servicio === TipoServicioEnumChoice.FIBRA) {
      if (!form.getValues().codigo_forma_pago)
        return setAlert(
          true,
          "Seleccionar una forma de pago.",
          AlertSeverityEnum.info,
        );
      const resp = await fetchCalcularValorInstalacion({
        id_prospecto: dataProspecto?.id_prospecto_pymes!,
        forma_pago: form.getValues().forma_pago!,
        score: +dataProspecto?.puntaje_score_empresa!,
        segmentacion: dataProspecto?.segmentacion!,
        es_pyme: true,
      });

      const valor_instalacion = resp.data.valor_instalacion;
      const iva = resp.data.iva;

      form.setValue(
        `items.${index}.valor_instalacion_total`,
        (valor_instalacion + iva).toFixed(2),
      );
      form.setValue(
        `items.${index}.valor_instalacion`,
        valor_instalacion.toFixed(2),
      );
      form.setValue(
        `items.${index}.valor_instalacion_iva`,
        valor_instalacion.toFixed(2),
      );
      form.setValue(`items.${index}.valor_plan`, plan.valor);
      form.setValue(
        `items.${index}.velocidad_subida_maxima`,
        plan.velocidad_subida_maxima,
      );
      form.setValue(`items.${index}.tipo_servicio`, plan.tipo_servicio);
      form.setValue(`items.${index}.tipo_plan`, plan.tipo_plan);
      return;
    }
  };

  const valorInstalacionCompleto = (pago: boolean) => {
    const itemEnlace = form.getValues().items;

    if (itemEnlace) {
      for (let index = 0; index < itemEnlace.length; index++) {
        const plan = plans.find((e) => e.codigo == itemEnlace[index].plan);
        if (plan) {
          enlaceValorInstalacion(plan, pago, index);
        }
      }
    }
  };

  ///* effect

  /* useEffect(() => {
    if (!isLoadingSector) {
      form.setValue("sector", dataPreventa?.sector_data?.codigo!)
    }
  }, [isLoadingSector]) */

  const handleValidarTipoVenta = useMemo(() => {
    if (dataProspecto?.solicitud_canje) {
      return TipoSolicitudesEnum.CANJE;
    }
    if (dataProspecto?.solicitud_evento) {
      return TipoSolicitudesEnum.EVENTO;
    }
    return TipoSolicitudesEnum.PYMES;
  }, [dataProspecto?.codigo]);

  useEffect(() => {
    if (form.getValues().items) {
      checkCoverage(CoordenadasPymesDefault, 0);
    }

    return () => {};
  }, []);

  useEffect(() => {
    if (prospectoResp) {
      setDataProspecto(prospectoResp);
    }

    return () => {};
  }, [prospectoResp?.id_prospecto_pymes]);

  useEffect(() => {
    if (handleValidarTipoVenta == TipoSolicitudesEnum.CANJE) {
      const coordCanje = dataProspecto?.solictud_canje_data.coordenadas;
      const direccion = dataProspecto?.solictud_canje_data.direccion;
      const nombre_contacto =
        dataProspecto?.solictud_canje_data.nombre_contacto;
      handleValoresCanjeEvento(coordCanje, nombre_contacto, direccion);
    }

    if (handleValidarTipoVenta == TipoSolicitudesEnum.EVENTO) {
      const coordCanje = dataProspecto?.solictud_evento_data.coordenadas;
      const direccion = dataProspecto?.solictud_evento_data.direccion;
      const nombre_contacto = dataProspecto?.solictud_evento_data.nombre;
      handleValoresCanjeEvento(coordCanje, nombre_contacto, direccion);
    }

    function handleValoresCanjeEvento(
      coordCanje: string | undefined,
      nombre_contacto: string | undefined,
      direccion: string | undefined,
    ) {
      form.setValue(`items.${0}.coordenada`, coordCanje!);
      form.setValue(`items.${0}.nombre`, nombre_contacto!);
      form.setValue(`items.${0}.direccion`, direccion!);
      checkCoverage(coordCanje!, form.getValues().items?.length! - 1);
    }
  }, [handleValidarTipoVenta]);

  /* useEffect(() => {

    return () => {
      //reset({})
    }
  }, [dataProspecto]) */

  useEffect(() => {
    if (!isLoadingParamRestriccionCel) {
      setValorRestriccionCel(
        dataParamRestriccionCel?.data?.data?.[0]?.valor 
        ? JSON.parse(dataParamRestriccionCel?.data?.data?.[0]?.valor) 
        : {}
      );
    }
  }, [isLoadingParamRestriccionCel, dataParamRestriccionCel])

  useLoaders(isPendingValorInstalacion);

  return {
    handleValidarTipoVenta,
    form,
    handleError,
    ///* tab personal
    handleBuscarRepresententeLegal,
    handleBuscarPorCedulaSetNombre,
    handleBuscarProspecto,
    handleSelectProspecto,
    prospectoRes: prospectoPreventa?.data.data,
    isLoadingProspecto,
    ///* tab residencia
    modalMapa,
    setModalMapa,
    /* MapComponent,
    latLng,
    setLatLng,
    napsByCity,
    isLoadingNapsByCity, */
    dataSector: dataSector?.data.data,
    isLoadingSector,
    dataProspecto,
    checkCoverage,
    fields,
    append,
    remove,

    ///* tab servicio
    handleFormaPago,
    isPendingValorInstalacion,
    dataCooperativa: dataCooperativa?.data.data,
    isLoadingCooperativa,
    handleValidarTarjeta,
    tipoTarjeta,
    handleSelectPlan,
    isLoadingEntidadFinanciero,
    dataEntidadFinanciero,
    handlePlanes,
    handleValorInstalacionFormaPago,
    //handleCalcularValorInstalacion,
    enlaceValorInstalacion,
    valorInstalacionCompleto,

    // V2 - 3 niveles de pago
    handleTipoPagoV2Change,
    handleEntidadV2Change,
    handleFormaPagoV2Change,
    entidadesV2Filtradas,
    isLoadingEntidadesV2,
    formasPagoV2Filtradas,
    isLoadingFormasPagoV2,
    selectedCardTypeName,

    ///* tab otros servicios

    ///* tab documentos
    handleOnSubmit,
    isPendingPreventa,
    isPendingUpdatePreventa,
    docHabilitantes,
    setDocHabilitantes,
    valorRestriccionCel
  };
};
